/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.loading_on = function () {
    document.getElementById("loading-overlay").style.display = "block";
};

window.loading_off = function () {
    document.getElementById("loading-overlay").style.display = "none";
};

window.isDecimal = function (value) {
    if (String(value).match(/^[-+]?[0-9]+(\.[0-9]+)?$/) && String(value) != "") {
        return true;
    }
    return false;
};


window.format_thai_date = function (date, includeTime = false) {
    var moment = require('moment');
    if (includeTime) {
        moment = moment(date).locale('th').format("LL LT"); // วันที่ + เวลา
    } else {
        moment = moment(date).locale('th').format("LL"); // วันที่อย่างเดียว
    }
    return moment
}

window.format_date = function (date) {
    var moment = require('moment');
    moment = moment(date).locale('th').format("D-M-Y")
    return moment
}
require("./bootstrap");

window.detectError = (error) => {
    console.error(error);
    axios.post("/liff/js-error", {
        message: error.message,
        name: error.name,
        stack: error.stack,
        cause: error.error,
        url: window.location.href
    })
}

window.Vue = require("vue").default;
import VueLazyload from 'vue-lazyload'
import * as fabric from 'fabric';
import liff from "@line/liff";
window.fabric = fabric
window.liff = liff;
Vue.mixin({
    methods: {
        formatNumber(n, dec = 2) {
            return new Intl.NumberFormat('us-US', {
                minimumFractionDigits: dec,
                maximumFractionDigits: dec
            }).format(n)
        },
        format_thai_date(date, includeTime = false) {
            return window.format_thai_date(date, includeTime)
        }
    }
})
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component(
//     "example-component",
//     require("./components/ExampleComponent.vue").default
// );
const loadimage = "../images/spinning-loading.gif"
const errorimage = "https://via.placeholder.com/150"
// To use Html5QrcodeScanner (more info below)
import { Html5QrcodeScanner } from "html5-qrcode";

// To use Html5Qrcode (more info below)
import { Html5Qrcode } from "html5-qrcode";
window.Html5Qrcode = Html5Qrcode
window.Html5QrcodeScanner = Html5QrcodeScanner
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: errorimage,
    loading: loadimage,
    attempt: 1
})
Vue.component("custom-date", require("./components/CustomDate.vue").default);
Vue.component("product-amount", require("./components/ProductAmount.vue").default);
Vue.component("pos-amount", require("./components/PosAmount.vue").default);
Vue.component("input-number-keyborad", require("./components/InputNumberKeyBoard.vue").default);
Vue.component("tree-select", require("./components/Treeselect.vue").default);
Vue.component("modal-select-product", require("./components/ModalSelectProducts.vue").default);
Vue.component("modal-req-transfer-product", require("./components/ModalReqTransferProducts.vue").default);
Vue.component("search-product-btn", require("./components/Pos/SearchProductBtn.vue").default);
Vue.component("modal-dosage-btn", require("./components/Pos/GetCartDosage.vue").default);
Vue.component("modal-customer", require("./components/Pos/ModalCustomer.vue").default);
Vue.component("modal-edit-product", require("./components/Pos/ModalEditProduct.vue").default);
Vue.component("number-keyboard", require("./components/Pos/NumberKeyboard.vue").default);
Vue.component("promotion-section", require("./components/Pos/PromotionSection.vue").default);
Vue.component("modal-discount", require("./components/Pos/ModalDiscount.vue").default);
Vue.component("modal-checkout-cash", require("./components/Pos/ModalCheckoutCash.vue").default);
Vue.component("qt-promotion-section", require("./components/QuotationPromotion.vue").default);
Vue.component("line-register", require("./components/Line/Register.vue").default);
Vue.component("line-modal-dosage", require("./components/Line/ModalDosage.vue").default);
Vue.component("line-layout", require("./components/Line/Layout.vue").default);
Vue.component("bill-date", require("./components/BillDate.vue").default);
Vue.component("line-loading", require("./components/Line/Loading.vue").default);

// LASA (Look-Alike Sound-Alike) Safety Components
Vue.component("lasa-alert-modal", require("./components/LasaAlertModal.vue").default);

Vue.component("stock-count-manage", require("./components/StockCountManage.vue").default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

